import React, {Component} from 'react';
import TableCell from "@amzn/meridian/table/table-cell";
import {FormattedMessage} from "react-intl";

/**
 * This class is currently used by floor view to show the bin details
 */
export default class BinTableCell extends Component {
    render() {

        const bin = this.props.bin
        const bag = this.getBag(bin)

        return bag ?
            <TableCell columnSpan={6}>
                <FormattedMessage id="bin.bin" defaultMessage="Bin"/> {bin.binLabel}&nbsp;
                <FormattedMessage id="bin.bag" defaultMessage="Bag"/> {bag.bagLabel}: ({bag.childCount})
                packages
            </TableCell>
            : null
    }

    getBag = (bin) => {
        // For AR Next Gen, we only show the details for the bag that is currently attached to the bin
        if (bin.bags && bin.bags.length === 1) {
            return bin.bags[0]
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/floor/BinTableCell.js